import * as React from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import IconButton from '@mui/material/IconButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Slide from '@mui/material/Slide';
import ID001 from '../../file/ID001.svg'
import { Typography } from '@mui/material';
import BoxDialogID001 from './Dialog';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


export default function BoxID001() {
    const [open, setOpen] = React.useState(false);
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('false');
    const [scroll, setScroll] = React.useState('paper');


    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleMaxWidthChange = (event) => {
        setMaxWidth(
            // @ts-expect-error autofill of arbitrary value is not handled.
            event.target.value,
        );
    };

    const handleFullWidthChange = (event) => {
        setFullWidth(event.target.checked);
    };

    return (
        <React.Fragment>
            <Box onClick={handleClickOpen('body')}>
                <Box sx={{ justifyContent: 'space-between ', display: 'flex', marginBottom: 3 }}>
                    <Typography sx={{ textTransform: 'uppercase', fontWeight: 600, fontSize: 15 }}>
                        Covid19-Data-News
                    </Typography>
                    <Typography sx={{ textTransform: 'uppercase', fontWeight: 600, fontSize: 15 }}>
                        ID: 001
                    </Typography>
                </Box>
                <img className='w-100% max-h-[550px] m-auto items-center  rounded-lg ' src={ID001} alt="" />
            </Box>

            <Dialog
                fullScreen
                maxWidth={maxWidth}
                open={open}
                onClose={handleClose}
                scroll={scroll}
                TransitionComponent={Transition}

                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogActions sx={{ cursor: 'pointer' }}>
                    <IconButton  >
                        <CloseRoundedIcon onClick={handleClose} sx={{ fontSize: 50 }}></CloseRoundedIcon>
                    </IconButton>
                </DialogActions>
                <DialogContent>
                    <BoxDialogID001 />
                    
                </DialogContent>

            </Dialog>
        </React.Fragment>
    )
}
